import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { TimeZoneEnum } from "../../data/enums";

export namespace AssociateValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            phone: baseVals.phone(),
            address: baseVals.string(),
            location: v.optional(baseVals.coordinate()),
            username: baseVals.username(),
            password: baseVals.password(),
            timeZone: v.picklist(TimeZoneEnum.values),
            billingDay: baseVals.intRange(1, 28, "Tanggal Tagihan Sistem"),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            phone: v.exactOptional(baseVals.phone()),
            address: v.exactOptional(baseVals.string()),
            location: v.exactOptional(baseVals.coordinate()),
            username: v.exactOptional(baseVals.username()),
            password: v.exactOptional(baseVals.password()),
        }),
    );

    export namespace Dev {
        export const Update = defineValidation(
            v.object({
                controlAudit: v.exactOptional(v.boolean()),
            }),
        );
    }
}
